// extracted by mini-css-extract-plugin
module.exports = {"content":"_8c559fa4c7--content--FX0or","average-price":"_8c559fa4c7--average-price--GkQ7l","quick-links":"_8c559fa4c7--quick-links--v_xwt"};